import styled, { css } from 'styled-components';

export const BigPlayButtonStyled = styled.div`
  ${({ backgroundPoster }) =>
    backgroundPoster
      ? css`
          background-size: cover;
          background: #000 url(${backgroundPoster}) no-repeat center center;
        `
      : css`
          background-color: #1a1a1a;
        `};
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99;
  top: 0;
  left: 0;
`;

export const StyledIconWrap = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  ${({ iconSize }) => css`
    width: ${iconSize}px;
    height: ${iconSize}px;

    svg {
      width: ${iconSize}px;
      height: ${iconSize}px;
    }
  `}
`;
